import { render, staticRenderFns } from "./WidgetDisplay.vue?vue&type=template&id=23eeeaf6&scoped=true"
import script from "./WidgetDisplay.vue?vue&type=script&lang=js"
export * from "./WidgetDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eeeaf6",
  null
  
)

export default component.exports